<template>
    <div id="app" :class="{'appDark': isDark}">
        <router-view/>
    </div>
</template>
<script>
// import api from "@/api/api";
import Vconsole from "vconsole";
import { getCookie } from '../src/utils/base'
export default {
    data () {
        return {
            consoleTools: false,
            test: 'abc'
        }
    },
    computed: {
        isDark () {
            return this.$store.state.common.isDark
        }
    },
    created () {
        if (this.getCookies('hyconsole') === '1' || process.env.NODE_ENV === 'development') {
            this.consoleTools = new Vconsole()
        }
    },
    mounted () {
        window.userInterfaceStyleChanged = this.userInterfaceStyleChanged;
    },
    watch: {
    },
    methods: {
        getCookies (key) {
            return getCookie(key)
        },
        userInterfaceStyleChanged (index) {
            // if (index * 1 === 1) {
            //     document.querySelector('html').style.backgroundColor = '#191919'
            //     document.querySelector('body').style.backgroundColor = '#191919'
            // } else {
            //     document.querySelector('html').style.backgroundColor = '#fff'
            //     document.querySelector('body').style.backgroundColor = '#fff'
            // }
            this.$store.commit('darkUpdate', index + '')
        }
    }
}
</script>
<style src="vant/lib/index.css"></style>
<style lang="less">
html, body {
    width: 100%;
    height: 100%;
}
p, h1, h2, h3,h4,h5,h6,span,ul,div{
    -webkit-touch-callout:none;  /*系统默认菜单被禁用*/
    -webkit-user-select:none; /*webkit浏览器*/
    -khtml-user-select:none; /*早期浏览器*/
    -moz-user-select:none; /*火狐*/
    -ms-user-select:none;  /*IE10*/
    user-select:none;
}
input, textarea{
    -webkit-user-select: auto!important;
    -khtml-user-select: auto!important;
    -moz-user-select: auto!important;
    -ms-user-select: auto!important;
    -o-user-select: auto!important;
    user-select: auto!important;
}
#app {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    // text-align: center;
    font-family:PingFangSC-Regular,PingFang SC,'Microsoft Yahei','Simsun',Tahoma;;
}
.appDark{
    background-color: #191919;
}
input,button,table,img{border:none;}
body,div,input,button,table,ul,ol,li,a,img,p,h1,h2,h3,h4,h5,h6,.inside{margin:0;padding:0;}
h1,h2,h3,h4,h5,h6{font-weight:normal;}
html{-webkit-text-size-adjust:none;}
input,textarea,select,button{outline:none;border:none;}
ul,li,dl,td,tr,dd{list-style:none;margin:0;padding:0;border:none;}
a{text-decoration:none;font-size:12px;}
a:hover{text-decoration:none;}
em,i{ font-style: normal;}
textarea{resize:none;}
</style>
